// extracted by mini-css-extract-plugin
export default {"container":"Privacy_container__eIFlC","heading":"Privacy_heading__crQjU","privacybackground":"Privacy_privacybackground__djcAA"};